"use client";

// Отправка ошибки фронта на сервер (заход 07.09). Не через api(): та при
// «Требуется авторизация» перезагружает страницу, а отчёт об ошибке обязан
// уйти тихо — с экрана входа, из error boundary, из падающего чанка.
//
// Тенант в проде сервер берёт из поддомена; на localhost — из x-tenant (тот же
// приём, что в api.ts). Токен добавляем, если есть: тогда в журнале оператора
// видно, у кого именно упало.

export type ClientErrorKind = "error" | "unhandledrejection" | "render" | "chunk";

const TOKEN_KEY = "mise_token";
const MAX_PER_LOAD = 12;
const DEDUP_MS = 30_000;

let sent = 0;
const recent = new Map<string, number>();

function tenantSlug(): string | null {
  if (typeof window === "undefined") return null;
  const labels = window.location.hostname.split(".");
  if (labels.length >= 2 && labels[0] && labels[0] !== "www") return labels[0].toLowerCase();
  return null;
}

export function reportClientError(kind: ClientErrorKind, message: string, stack?: string | null, extra?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  if (sent >= MAX_PER_LOAD) return;
  const key = `${kind}:${message.slice(0, 200)}`;
  const now = Date.now();
  const last = recent.get(key);
  if (last && now - last < DEDUP_MS) return;
  recent.set(key, now);
  sent += 1;

  const headers: Record<string, string> = { "content-type": "application/json" };
  const slug = tenantSlug();
  if (slug) headers["x-tenant"] = slug;
  try {
    const token = window.localStorage.getItem(TOKEN_KEY);
    if (token) headers["authorization"] = `Bearer ${token}`;
  } catch {
    /* localStorage недоступен — отчёт без пользователя */
  }
  const payload = {
    kind,
    message: message.slice(0, 2000),
    stack: (stack ?? "").slice(0, 8000),
    url: window.location.pathname + window.location.search,
    build: process.env.NEXT_PUBLIC_BUILD ?? null,
    userAgent: navigator.userAgent.slice(0, 300),
    extra: extra ?? null,
  };
  try {
    void fetch("/api?action=reportClientError", {
      method: "POST",
      headers,
      body: JSON.stringify({ action: "reportClientError", payload }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* fetch недоступен — ничего не делаем */
  }
}

// Падение чанка после деплоя: у страницы старая сборка, а её файлов на сервере
// уже нет. Единственное лекарство — перезагрузка; делаем её один раз в минуту,
// чтобы не зациклиться, если сервер действительно лежит.
export function isChunkLoadError(message: string): boolean {
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(message);
}

export function reloadOnceForChunk(): boolean {
  try {
    const key = "klait_chunk_reload_at";
    const last = Number(window.sessionStorage.getItem(key) ?? 0);
    if (Date.now() - last < 60_000) return false;
    window.sessionStorage.setItem(key, String(Date.now()));
  } catch {
    /* sessionStorage недоступен — всё равно перезагрузим один раз */
  }
  window.location.reload();
  return true;
}
